import styled from 'styled-components';

import { CrossIcon } from '~/assets';
import matchbackSpinner from '~/assets/matchback-spinner.png';
import { ThemeProp } from '~/theme/Themes';

interface DownloadContainerProps {
  $darkMode?: boolean;
  // Overrides for callers with their own exact size spec (e.g. Matchbacks); default to the
  // existing shared look everywhere else.
  $width?: string;
  $height?: string;
  $gap?: string;
  $borderRadius?: string;
  $borderColor?: string;
  $boxShadow?: string;
}

export const DownloadContainer = styled.div<DownloadContainerProps>`
  display: flex;
  justify-content: space-between;
  padding: 0.5rem;
  background-color: ${(props: ThemeProp & DownloadContainerProps) =>
    props.$darkMode ? props.theme.colors.neutrals.c800 : props.theme.colors.neutrals.white};
  align-items: center;
  gap: ${(props: DownloadContainerProps) => props.$gap || '1rem'};
  width: ${(props: DownloadContainerProps) => props.$width || 'auto'};
  min-width: ${(props: DownloadContainerProps) => (props.$width ? 'unset' : '25rem')};
  height: ${(props: DownloadContainerProps) => props.$height || 'auto'};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  box-shadow: ${(props: DownloadContainerProps) => props.$boxShadow || '0 16px 32px 0 rgba(30, 41, 59, 0.08)'};
  border: 1px solid
    ${(props: ThemeProp & DownloadContainerProps) => props.$borderColor || props.theme.colors.neutrals.c100};
  border-radius: ${(props: DownloadContainerProps) => props.$borderRadius || '0.5rem'};
  color: ${(props: ThemeProp & DownloadContainerProps) =>
    props.$darkMode ? props.theme.colors.neutrals.white : props.theme.colors.neutrals.black};

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
    bottom: 3rem;
    min-width: unset;
  }
`;

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  justify-content: center;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2rem;
  border-radius: 0.375rem;
  width: 2rem;
`;

interface IconContainerColorProps {
  $iconBackgroundColor?: string;
}

export const TickContainer = styled(IconContainer)<IconContainerColorProps>`
  background-color: ${(props: ThemeProp & IconContainerColorProps) =>
    props.$iconBackgroundColor || props.theme.colors.success};
  stroke: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
`;

export const InformationContainer = styled(IconContainer)`
  background-color: ${(props: ThemeProp) => props.theme.colors.primary.c600};
  stroke: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
`;

export const SpinnerIcon = styled.div`
  width: 1rem;
  height: 1rem;
  flex-shrink: 0;
  background-image: url(${matchbackSpinner});
  background-size: contain;
  background-repeat: no-repeat;
  animation: toast-spinner-rotate 0.8s linear infinite;

  @keyframes toast-spinner-rotate {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const CrossContainer = styled(IconContainer)<IconContainerColorProps>`
  background-color: ${(props: ThemeProp & IconContainerColorProps) =>
    props.$iconBackgroundColor || props.theme.colors.darkRed};
  stroke: ${(props: ThemeProp) => props.theme.colors.neutrals.white};
`;

export const StyledCrossIcon = styled(CrossIcon)`
  stroke: ${(props: ThemeProp) => props.theme.colors.neutrals.c300};
  cursor: pointer;
`;
